/**
 * O status que SOME SOZINHO, idêntico ao do admin atual (peça transversal 5 do inventário).
 *
 * No legado, cada área tem a sua `mostrarStatus*` (`admin.html:7057`, `7139`, `7314`, `8816`,
 * `9171`, `9199` e outras): escreve a mensagem e, depois do prazo, apaga, MAS só se ela ainda for a
 * mesma. Uma mensagem nova no meio do caminho não é apagada pelo relógio da anterior. O prazo é 3 s
 * em quase todas, e 5 s em "Acesso criado!" e no "Enviado!" do e-mail, por isso ele é parâmetro.
 *
 * O parágrafo que mostra o status é o `LinhaDeStatus`, com `role="status"` como o legado
 * (`admin.html:1981`), escrito sem JSX para esta peça continuar num arquivo `.ts`.
 *
 * Dona desta peça: a frente A5 (Financeiro e Sistema), por designação do principal em 19/09/2026.
 */

// Estado, referência, memória e o criador de elemento do React.
import { createElement, useCallback, useRef, useState } from 'react';

/**
 * O gancho: devolve o texto atual, `mostrar` (que apaga sozinho depois do prazo) e `fixar` (que
 * não apaga: o legado escreve assim alguns status, como o erro da visibilidade de aba e o do
 * roteiro, e o texto fica até a próxima mensagem).
 */
export function useStatusTemporario(
  // 3000 ms: o prazo da maioria dos status do legado.
  prazoMs = 3000,
): readonly [string, (mensagem: string) => void, (mensagem: string) => void] {
  const [texto, setTexto] = useState('');
  // A mensagem visível, lida pelo relógio sem depender do render em que ele nasceu.
  const atual = useRef('');
  // Mostra e agenda a limpeza, como o `setTimeout` do legado.
  const mostrar = useCallback(
    (mensagem: string) => {
      atual.current = mensagem;
      setTexto(mensagem);
      window.setTimeout(() => {
        // Só apaga se ainda for a mesma: o `if (el.textContent === msg)` do legado.
        if (atual.current === mensagem) {
          atual.current = '';
          setTexto('');
        }
      }, prazoMs);
    },
    [prazoMs],
  );
  // Mostra sem agendar a limpeza.
  const fixar = useCallback((mensagem: string) => {
    atual.current = mensagem;
    setTexto(mensagem);
  }, []);
  return [texto, mostrar, fixar] as const;
}

/**
 * O parágrafo do status. A altura mínima reserva a linha para a tela não pular quando a mensagem
 * aparece e some.
 */
export function LinhaDeStatus({ texto, testid }: { readonly texto: string; readonly testid?: string }) {
  return createElement(
    'p',
    { role: 'status', 'data-testid': testid, className: 'min-h-[1.25rem] text-cx-sm text-texto-suave' },
    texto,
  );
}
